import { SwitchProps } from '@mui/material/Switch';

import { StyledToggleButton } from './ToggleSwitch.styled';

export function ToggleSwitch(properties: SwitchProps) {
    return (
        <StyledToggleButton
            focusVisibleClassName=".Mui-focusVisible"
            data-testid="toggle-switch"
            disableRipple
            {...properties}
        />
    );
}
